// axios
import axios from 'axios'
 // const domain = process.env.VUE_APP_MY_ENV_VARIABLE
 //const domain = "https://localhost:44381/"
 const domain = 'https://api.unitedats-tms.com/'
  //const domain = "https://api.iace.academy/"

  //  test API version
  //const domain = 'http://161.97.97.9:5555/'

export default axios.create({
  baseURL : domain
  // You can add your headers here
})
